<template>
  <div>
    <div class="row d-flex justify-content-center">
      <div class="col-md-12 mr-auto ml-auto">
          <simple-wizard @tab-change="changeTab" finishButtonText="Save Proramme">
            <template slot="header">
              <h3 class="card-title">{{ pageTitle }}</h3>
              <h3 class="description">{{ pageDesc }}</h3>
            </template>

            <wizard-tab :before-change="() => validateStep('step1')">
              <template slot="label">
                <i class="now-ui-icons business_globe"></i>
                Details
              </template>
              <first-step ref="step1" @on-validated="onStepValidated" :batches="transfer_batches_step_1" :programme="wizardModel" :scope="scope"></first-step>
            </wizard-tab>

            <wizard-tab :before-change="() => validateStep('step2')">
              <template slot="label" >
                <i class="now-ui-icons files_single-copy-04"></i>
                Events
              </template>
              <second-step v-if="isStep2Active" ref="step2" @on-validated="onStepValidated" :batches="transfer_batches_step_2" :login="wizardModel.login" :pool="wizardModel.pool" :events="wizardModel.events" :scope="scope"></second-step>
            </wizard-tab>

            <wizard-tab :before-change="() => validateStep('step3')">
              <template slot="label">
                <i class="now-ui-icons design_image"></i>
                Preview
              </template>
              <third-step v-if="isStep3Active" ref="step3" :programme="wizardModel" :batches="batches"  @on-validated="wizardComplete" :scope="scope"></third-step>
            </wizard-tab>
          </simple-wizard>
      </div>
    </div>
  </div>
</template>
<script>
import FirstStep from './Steps/FirstStep.vue';
import SecondStep from './Steps/SecondStep.vue';
import ThirdStep from './Steps/ThirdStep.vue';
import swal from 'sweetalert2';
import { SimpleWizard, WizardTab } from 'src/components';
import { mapGetters } from 'vuex';

export default {
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    SimpleWizard,
    WizardTab
  },
  mounted(){
    this.scope = this.$route.path.includes('/edit') ? 'edit' : 'create'
    this.$store.dispatch('getBatches')

    if(this.scope == 'edit'){
      this.$store.dispatch('getProgramme', this.$route.params.slug)
    }
  },
  watch:{
    programme(programmeValue){

        this.wizardModel = programmeValue

        let batches = []
        this.wizardModel.batches.forEach((batch, index) => {
            batches.push(this.batches.findIndex((item) => item == batch))
        })
        this.wizardModel.batches = batches

        this.wizardModel.events.forEach((event, index) => {
          let batches = []
          event.batches.forEach((batch, index) => {
              batches.push(this.transfer_batches_step_1.findIndex((item) => item.label == batch))
          })
          event.batches = batches
        })
        
    },
    batches(batchesVal){
      if(this.wizardModel != null){
        if(this.wizardModel.batches){
          let batches = []
          this.wizardModel.batches.forEach((batch, index) => {
              batches.push(this.batches.findIndex((item) => item == batch))
          })
          this.wizardModel.batches = batches
        }

        if(this.wizardModel.events){
          this.wizardModel.events.forEach((event, index) => {
            let batches = []
            event.batches.forEach((batch, index) => {
                batches.push(this.transfer_batches_step_1.findIndex((item) => item.label == batch))
            })
            event.batches = batches
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters({
        programme: 'getProgramme',
        batches: 'getBatches'
    }),
    pageTitle(){
      return `${this.scope} Programme`
    },
    pageDesc(){
      let verb = this.scope == 'create' ? 'creation' : 'updation'
      return `Provide relavent information for the ${verb} of a new programme.`
    },
    transfer_batches_step_1(){
        let batches = []
        if(this.batches)
            this.batches.forEach((batch, index) => {
                batches.push({
                    label: batch,
                    key: index
                });
            });
        return batches;
    },
    transfer_batches_step_2(){
      let batches = []
      this.wizardModel.batches.forEach((batch) => {
        batches.push(this.transfer_batches_step_1.find((item) => item.key == batch))
      })
      return batches
    },
    // final_programme(){
    //   let prgm = Object.assign({}, this.wizardModel)
    //   // let batches = []
    //   // prgm.batches.forEach((batch, index) => {
    //   //     batches.push(this.batches[batch])
    //   // })
    //   // prgm.batches = batches

    //   // prgm.events.forEach((event, index) => {
    //   //   let batches = []
    //   //   event.batches.forEach((batch, index) => {
    //   //       batches.push(this.batches[batch])
    //   //   })
    //   //   event.batches = batches
    //   // })
    //   return prgm
    // }
  },
  data() {
    return {
      scope: 'create',
      isStep2Active: false,
      isStep3Active: false,
      wizardModel: null
    };
  },
  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
      // this.wizardModel = model
    },
    wizardComplete(validated, model) {
      // model.programme_id = "123456789011";
      this.wizardModel = { ...this.wizardModel, ...model };
      // this.wizardModel = model

      let batches = []
      this.wizardModel.batches.forEach((batch, index) => {
          batches.push(this.batches[batch])
      })
      this.wizardModel.batches = batches

      this.wizardModel.events.forEach((event) => {
        let batches = []
        event.batches.forEach((batch, index) => {
            batches.push(this.batches[batch])
        })
        event.batches = batches
      })

      console.log(this.scope, this.wizardModel);

      // check if batches are all not null
      if(this.wizardModel.batches.every(item => item != null)){
        if(this.scope == 'create')
          this.$store.dispatch('createProgramme', this.wizardModel)
        else
          this.$store.dispatch('updateProgramme', this.wizardModel)
      }
      else{
        console.log('batches included null value.');
      }

      

    },
    changeTab(oldTab, newTab){
      this.isStep3Active = Boolean(newTab.tabId === "2");
      this.isStep2Active = Boolean(newTab.tabId === "1");
    }
  }
};
</script>
<style scoped>
  .card-title{
    text-transform: capitalize;
  }
</style>
